/** Weekday bitmask as in specs/01: ma=1, di=2, wo=4, do=8, vr=16, za=32, zo=64. */
export const WEEKDAYS = [
  { bit: 1, short: 'ma', long: 'maandag' },
  { bit: 2, short: 'di', long: 'dinsdag' },
  { bit: 4, short: 'wo', long: 'woensdag' },
  { bit: 8, short: 'do', long: 'donderdag' },
  { bit: 16, short: 'vr', long: 'vrijdag' },
  { bit: 32, short: 'za', long: 'zaterdag' },
  { bit: 64, short: 'zo', long: 'zondag' },
] as const;

export const ALL_WEEKDAYS = 127;

export function hasDay(mask: number, bit: number): boolean {
  return (mask & bit) === bit;
}

export function toggleDay(mask: number, bit: number): number {
  return mask ^ bit;
}

export function weekdaysLabel(mask: number): string {
  if (mask === ALL_WEEKDAYS) return 'elke dag';
  if (mask === 31) return 'ma t/m vr';
  if (mask === 96) return 'weekend';
  if (mask === 0) return 'geen dagen';
  return WEEKDAYS.filter((d) => hasDay(mask, d.bit))
    .map((d) => d.short)
    .join(', ');
}

export function minutesToTime(min: number): string {
  if (min >= 1440) return '24:00';
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function timeToMinutes(t: string): number | null {
  const m = /^(\d{1,2}):(\d{2})$/.exec(t);
  if (!m) return null;
  const h = Number(m[1]);
  const mm = Number(m[2]);
  if (h > 24 || mm > 59 || (h === 24 && mm > 0)) return null;
  return h * 60 + mm;
}

export function windowLabel(r: { all_day: boolean; start_minute: number; end_minute: number }): string {
  if (r.all_day) return 'hele dag';
  return `${minutesToTime(r.start_minute)}–${minutesToTime(r.end_minute)}`;
}
